import React from "react";
import {
	Datagrid,
	DateField,
	FunctionField,
	List,
	TextField,
	useTranslate,
} from "react-admin";
import { UserReferenceField } from "../../users";
import CustomPagination from "../../utils/CustomPagination";
import SectionTitle from "../../utils/SectionTitle";
import ModerationActivitiesFilter from "./ModerationActivitiesFilter";
import styles from "./ModerationActivitiesList.module.scss";

const ModerationActivitiesList = () => {
	const translate = useTranslate();

	return (
		<>
			<SectionTitle
				title={translate("resources.moderation_activities.name", {
					smart_count: 2,
				})}
				subtitle={translate("resources.moderation_activities.subtitle")}
			/>
			<div className={styles.root}>
				<List
					resource="moderation_activities"
					sort={{ field: "id", order: "DESC" }}
					filters={<ModerationActivitiesFilter />}
					pagination={<CustomPagination />}
					disableSyncWithLocation
				>
					<Datagrid bulkActionButtons={false}>
						<TextField source="identifier" label="ID" />

						<TextField
							source="content"
							label={translate(
								"resources.moderation_activities.fields.content",
							)}
						/>

						<FunctionField
							label={translate("resources.moderation_activities.fields.mode")}
							render={(record) => {
								return record.mode === "manual"
									? translate("resources.moderation_activities.mode.manual")
									: translate("resources.moderation_activities.mode.auto", {
											provider: record.mode,
										});
							}}
						/>

						<FunctionField
							label={translate(
								"resources.moderation_activities.fields.previous_status",
							)}
							render={(record) => {
								return translate(
									`resources.comments.status.${
										record.previous_status || "undefined"
									}`,
								);
							}}
						/>
						<FunctionField
							label={translate(
								"resources.moderation_activities.fields.new_status",
							)}
							render={(record) => {
								return translate(
									`resources.comments.status.${
										record.new_status || "undefined"
									}`,
								);
							}}
						/>

						<FunctionField
							render={(record) => record.notes || "-"}
							label={translate("resources.moderation_activities.fields.notes")}
						/>

						<UserReferenceField
							source="user"
							targetId="user.hash_id"
							label={translate("resources.moderation_activities.fields.user")}
						/>
						<DateField
							source="created_at"
							label={translate(
								"resources.moderation_activities.fields.created_at",
							)}
							showTime={true}
						/>
					</Datagrid>
				</List>
			</div>
		</>
	);
};

export default ModerationActivitiesList;
